module.exports = __webpack_public_path__ + "static/contract-package-3-d8068c3b1e0827addc0d2e6aa51928fd.pdf";